import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <header className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20editorial%20flat%20lay%20photography%20with%20curated%20fashion%20items%20including%20stylish%20sneakers%20cozy%20knitwear%20and%20modern%20accessories%20arranged%20on%20warm%20sand%20colored%20linen%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20large%20window%2C%20European%20high%20end%20catalog%20aesthetic%20with%20organic%20composition%2C%20gentle%20shadows%20and%20airy%20sophisticated%20atmosphere%2C%20warm%20neutral%20tones%20throughout&width=1600&height=900&seq=kakobuy-hero-bg-v2&orientation=landscape"
        alt="Kakobuy Spreadsheet Polska"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-5 leading-tight font-heading">
          {t('hero_title')}
        </h1>
        <p className="text-sm md:text-lg text-white/90 max-w-2xl mx-auto mb-7 md:mb-8 leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-7 py-3 rounded-full text-sm md:text-base transition-all duration-200 hover:scale-105"
          >
            <i className="ri-fire-line w-5 h-5 flex items-center justify-center"></i>
            {t('cta_spreadsheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white/95 hover:bg-white text-foreground-900 font-semibold px-7 py-3 rounded-full text-sm md:text-base transition-all duration-200 hover:scale-105"
          >
            <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center"></i>
            {t('cta_buy_now')}
          </a>
        </div>
      </div>
    </header>
  );
}